import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import {Bindings} from "data/constants/bindings";
import {ViewController} from "data/types/structure";
import type {IUserStore} from "data/stores/user/user.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface IAccountController extends ViewController {
	i18n: ILocalizationStore;
	logoutHandler: () => void;
}

@injectable()
export class AccountController implements IAccountController {
	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	logoutHandler = () => {
		window.gigya?.accounts.logout();
	};
}
